import {
	SET_PRODUCTS,
	SET_PRODUCT,
	CLEAR_PRODUCTS,
	CLEAR_PRODUCT,
	ADD_PRODUCT,
	UPDATE_PRODUCT,
	REMOVE_PRODUCT,
} from './actionTypes';

export const product = (state = {}, action) => {
	switch (action.type) {
		case SET_PRODUCT:
			return action.payload;
		case UPDATE_PRODUCT:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_PRODUCT:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_PRODUCTS:
			return action.payload;
		case ADD_PRODUCT:
			return [...state, action.payload];
		case UPDATE_PRODUCT:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_PRODUCT:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_PRODUCTS:
			return [];
		default:
			return state;
	}
};
